import { app } from '../../app';
import { Controller } from './sp-account-type.controller';

app.component('spAccountType', {
    bindings: {
        accountType: '<',
        tooltipPlacement: '@',
    },
    controller: Controller,
    templateUrl: require('./sp-account-type.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-account-type/sp-account-type.component.js